<template>
  <div class="main-div">
    <h1>Payment Failed</h1>

  </div>
</template>

<script setup>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

import { useRoute} from 'vue-router'


const route = useRoute();

async function home(term) {
  router.push({ path: '/payment/fail' })
}


</script>

<style lang="scss" scoped>

a {
  text-decoration: none;
    color:#dfe0e0;
}

.main-div {
  margin: 20px;

}

.plan_name {
  font-style: italic;
}

.link-button {
  background: #0c396d;
  width: 220px;
  padding: 8px;
  border: solid;
  border-radius: 6px;
  color: white;
  text-align: center;
  cursor: pointer;
}

.link-button:hover {
  background:  #092145;

}

</style>
